import React from 'react';
import { Form, Radio, Button, Icon, Divider, Search } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import _ from 'lodash';
import storeArray from '../utilities/storeList';

import styled from 'styled-components';
import { ErrorMessage } from 'formik';

import FormikInputField from '../componentsFormik/FormikInputField';

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const initialState = { isLoading: false, results: [] };

const storeList = storeArray.map(store => {
  const parsedStore = JSON.parse(store);
  return {
    title: parsedStore.store,
    description: parsedStore.address
  }
})

class AQQuestionnaire extends React.Component<any, any> {
  state = initialState;

  navigate = (
    step: number | string,
    backStep: (null | number | string) = null,
    percent: (null | number) = null,
    motivation: (null | string) = null,
    e: any,
    props?: any,
    validate?: boolean
  ) => {
    e.preventDefault();

    if (validate) {
      this.props.gaEvent('event', 'QuestionnaireSubmit', 'Next', 'Boots', this.props.isValid);
    }

    this.props.manualStep(step, backStep, percent, motivation, props, validate);
  };

  reInitializeFields = () => {
    [
      'aq_maidenName',
      'aq_employeeNum',
      'aq_jobTitle',
      'aq_nationalInsurance',
      'aq_dateStarted',
      'aq_dateEnded',
      'aq_jobCode',
      'aq_branchName',
      'aq_branchNumber',
      'aq_branchAddress',
      'aq_hourlyPay',
      'aq_hoursPerWeek',
      'aq_jobChangedLastSixYears'
    ].map((field) => {
      return this.props.setFieldValue(field, '');
    });
  }

  handleResultSelect = (e: object, vals: any) => {
    const { title, description } = vals.result;
    this.props.setFieldValue('aq_branchName', title);
    this.props.setFieldValue('aq_branchAddress', description);

  };

  handleSearchChange = (e: object, vals: any) => {
    const { value } = vals;
    this.setState({ isLoading: true });
    this.props.setFieldValue('aq_branchName', value);

    setTimeout(() => {
      const val = this.props.values.aq_branchName
      if (val < 1) {
        this.props.setFieldValue('aq_branchName', '');
        return this.setState(initialState);
      };

      const re = new RegExp(val, 'i');
      const isMatch = (result: any) => { return re.test(result.title) || re.test(result.description) };

      this.setState({
        isLoading: false,
        results: _.filter(storeList, isMatch).slice(0, 4)
      })
    }, 500);
  }

  render() {
    const { isLoading, results } = this.state;
    return (
      <React.Fragment>
        <h1>Questionnaire</h1>

        <Button.Group widths="2">
          <Button
            color='green'
            content='Upload A Payslip Instead'
            onClick={(e) => {
              this.reInitializeFields();
              this.props.setFieldValue('aq_type', 'Payslip');
              this.navigate('PAYSLIP', null, null, null, e, null, false)
            }}
            style={{ marginBottom: '1rem' }}
            type='button'
          />
        </Button.Group>

        <FormikInputField
          name="aq_maidenName"
          type="input"
          label="Maiden Name (if applicable)"
          data-testid="pd-input-maiden-name"
        />

        <Divider />

        <FormikInputField
          name="aq_employeeNum"
          type="input"
          label="Employee Number"
          placeholder=""
        />

        <FormikInputField
          name="aq_jobTitle"
          type="input"
          label="Job Title"
          placeholder=""
        />

        <FormikInputField
          name="aq_nationalInsurance"
          type="input"
          label="NI Number"
          placeholder="QQ 12 34 56 C"
          data-testid="pd-input-ni"
        />

        <Form.Group grouped>
          <DateInput
            label="Date Started"
            id="aq_dateStarted"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_dateStarted"
            value={this.props.values.aq_dateStarted}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_dateStarted'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Form.Group grouped>
          <DateInput
            label="Date Ended"
            id="aq_dateEnded"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_dateEnded"
            value={this.props.values.aq_dateEnded}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_dateEnded'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <FormikInputField
          name="aq_jobCode"
          type="input"
          label="Job Code"
          placeholder=""
        />

        <Form.Group grouped>
          <label>What Boots store do/did you work at?</label>
          <Search
            input={{ fluid: true }}
            fluid
            loading={isLoading}
            name="aq_branchName"
            placeholder="Manchester"
            onResultSelect={this.handleResultSelect}
            onSearchChange={this.handleSearchChange}
            results={results}
            value={this.props.values.aq_branchName}
          />
        </Form.Group>

        <FormikInputField
          name="aq_branchNumber"
          type="input"
          label="Branch Number (if known)"
          placeholder=""
        />

        <FormikInputField
          name="aq_hourlyPay"
          type="input"
          label="Hourly Pay"
          placeholder=""
        />

        <FormikInputField
          name="aq_hoursPerWeek"
          type="input"
          label="Hours Worked Per Week"
          placeholder=""
        />

        <Form.Group grouped>
          <label>Has your job at Boots changed in the last 6 years?</label>
          <Form.Field>
            <Radio
              label="No"
              name="aq_jobChangedLastSixYears"
              value="No"
              checked={this.props.values.aq_jobChangedLastSixYears === 'No'}
              onChange={() => this.props.setFieldValue('aq_jobChangedLastSixYears', 'No')}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Yes (we will ask you to describe your previous job on the next page of the questionnaire)"
              name="aq_jobChangedLastSixYears"
              value="Yes"
              checked={this.props.values.aq_jobChangedLastSixYears === 'Yes'}
              onChange={() => this.props.setFieldValue('aq_jobChangedLastSixYears', 'Yes')}
            />
          </Form.Field>
          <ErrorMessage
            name={'aq_jobChangedLastSixYears'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>


        <Button.Group widths="2">
          <Button
            labelPosition="right"
            floated="right"
            color={this.props.isValid ? 'green' : 'grey'}
            icon="right chevron"
            content={this.props.values.aq_jobChangedLastSixYears === 'No' ? 'Submit' : 'Next'}
            onClick={(e) => {
              let submitOrNext = this.props.values.aq_jobChangedLastSixYears === 'No' ? 'FINALLY' : 'PREVIOUS_JOBS';
              this.navigate(submitOrNext, 'QUESTIONNAIRE', null, null, e, this.props, true);
            }}
          />
        </Button.Group>
      </React.Fragment>
    );
  }
}

export default AQQuestionnaire;
